module.exports = __webpack_public_path__ + "img/dstv-login-1.e20af6ee.jpg";